// extracted by css-extract-rspack-plugin
export default {"cls1":"BibliographyList-cls1_EEx","cls2":"BibliographyList-cls2_-oJ BibliographyList-cls1_EEx"};